module.exports = __webpack_public_path__ + "media/transport_protocols/Bookings-2c93f03c.svg";